import React, { useState } from "react";
import { Stack, Typography, IconButton } from "@mui/material";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import CloseIcon from "@mui/icons-material/Close";
import IOSSwitch from "../../IOSSwitch";
import { toast } from "react-toastify";
import { useDispatch } from "react-redux";
import { setLockAccessCodes } from "../../../redux/reducers/segmentBuilder";
import { colors } from "../../../utils";

const KeyList = ({ keys, setKeys, toggleIsActive }) => {
  const dispatch = useDispatch();
  const handleRemoveKey = (index) => {
    const newKeys = keys.filter((_, idx) => idx !== index);
    // dispatch(setLockAccessCodes(newKeys));
    setKeys(newKeys);
  };

  const handleCopyKey = (key) => {
    navigator.clipboard.writeText(key);
    toast.success('Key copied to clipboard!');
  };

  return (
    <div
      style={{ overflowY: "scroll", maxHeight: 150 }}
    >
      {keys.map((key, index) => (
        <Stack
          direction={"row"}
          alignItems={"center"}
          gap={2}
          marginTop={index > 0 ? 2 : 0}
        >
          <Stack direction={"row"} gap={1} alignItems={"center"}>
            <IOSSwitch
              checked={key.is_active}
              onChange={() => toggleIsActive(index)}
              color="primary"
              colorSwitch={colors.PrimaryPurple}
            />
            <Stack
              gap={1}
              direction={"row"}
              alignItems={"center"}
              sx={{ px: 2 }}
              justifyContent={"space-between"}
              style={{
                backgroundColor: "#F6F7F9",
                borderRadius: 50,

                minWidth: 200,
              }}
            >
              <Typography
                style={{ fontFamily: "DM Sans", fontWeight: 400 }}
                variant="caption"
              >
                {key.code}
              </Typography>
              <IconButton
                onClick={() => {
                  handleCopyKey(key.code)
                }}
              >
                <ContentCopyIcon
                  onpres
                  style={{ color: "#323232", fontSize: "16px" }}
                ></ContentCopyIcon>
              </IconButton>
            </Stack>
          </Stack>
          <IconButton
            onClick={() => {
              handleRemoveKey(index)
            }}
          >
            <CloseIcon style={{ color: "#BBBBBB", fontSize: 16 }}></CloseIcon>
          </IconButton>
        </Stack>
      ))}
    </div>
  );
};

export default KeyList;
